import { render, staticRenderFns } from "./Returns.vue?vue&type=template&id=fcc7ea28&scoped=true"
import script from "./Returns.vue?vue&type=script&lang=js"
export * from "./Returns.vue?vue&type=script&lang=js"
import style0 from "./Returns.vue?vue&type=style&index=0&id=fcc7ea28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc7ea28",
  null
  
)

export default component.exports